// Static constants shared by the UI (all data now comes from the backend API)

export const ROLES = [
  { id: 'system_admin', name: 'System administrator', description: 'Global configuration, security, integrations.' },
  { id: 'config_admin', name: 'KYC configuration admin', description: 'Fields, documents, classes, requirements.' },
  { id: 'operations', name: 'Requester / operations', description: 'Create records, initiate requests, view progress.' },
  { id: 'reviewer', name: 'Reviewer', description: 'Approve, reject or return items.' },
  { id: 'senior_approver', name: 'Senior approver', description: 'Second-level approval, overrides and waivers.' },
  { id: 'auditor', name: 'Auditor / compliance viewer', description: 'Read-only access to records, decisions and audit.' },
  { id: 'privacy_officer', name: 'Data privacy officer', description: 'Legal holds, retention and disposal.' },
];

export const DATA_TYPES = [
  'short_text', 'long_text', 'integer', 'decimal', 'percentage', 'currency', 'boolean', 'date', 'datetime', 'time',
  'email', 'telephone', 'url', 'country', 'address', 'single_select', 'multi_select', 'identifier', 'reference',
  'calculated', 'api_derived', 'confidential',
];

export const REJECTION_CODES = [
  { code: 'ILLEGIBLE', label: 'Illegible or low quality' },
  { code: 'EXPIRED', label: 'Document expired' },
  { code: 'MISMATCH', label: 'Details do not match record' },
  { code: 'INCOMPLETE', label: 'Missing pages or sides' },
  { code: 'WRONG_TYPE', label: 'Wrong document type' },
  { code: 'TAMPERED', label: 'Tampering indicators' },
  { code: 'OUTDATED', label: 'Older than allowed window' },
  { code: 'OTHER', label: 'Other (explain)' },
];

export const COUNTRIES = [
  ['GB', 'United Kingdom'], ['US', 'United States'], ['DE', 'Germany'], ['FR', 'France'], ['SE', 'Sweden'], ['NG', 'Nigeria'], ['IN', 'India'], ['IE', 'Ireland'], ['NL', 'Netherlands'], ['ES', 'Spain'], ['IT', 'Italy'], ['SG', 'Singapore'], ['AE', 'United Arab Emirates'], ['CA', 'Canada'], ['AU', 'Australia'],
];
